import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const BizCtx = createContext(null);

export function BusinessProvider({ children }) {
  const { user } = useAuth();
  const [businesses, setBusinesses] = useState([]);
  const [currentId, setCurrentId] = useState(localStorage.getItem("hn_business"));
  const canLoad = user && (user.license_active || user.role === "superadmin");

  const reload = useCallback(async () => {
    const { data } = await api.get("/businesses");
    setBusinesses(data);
    setCurrentId((prev) => (data.find((b) => b.id === prev) ? prev : data[0]?.id || null));
  }, []);

  useEffect(() => {
    if (canLoad) {
      reload();
    } else {
      setBusinesses([]);
    }
  }, [canLoad, reload]);

  useEffect(() => {
    if (currentId) localStorage.setItem("hn_business", currentId);
  }, [currentId]);

  const current = businesses.find((b) => b.id === currentId) || null;
  return (
    <BizCtx.Provider value={{ businesses, current, setCurrentId, reload }}>{children}</BizCtx.Provider>
  );
}

export const useBusiness = () => useContext(BizCtx);
